import React, { useEffect, useState } from "react";
import { FaEnvelope, FaInstagram } from "react-icons/fa";
import {
  FooterContent1,
  footerContent1Service,
} from "../../../services/footer/alamat";
import {
  FooterContent2,
  footerContent2Service,
} from "../../../services/footer/maps";
import {
  FooterContent3,
  footerContent3Service,
} from "../../../services/footer/contact";
import {
  FooterContent4,
  footercontent4Service,
} from "../../../services/footer/timeline";
import {
  FooterContent6,
  footercontent6Service,
} from "../../../services/footer/sosialmedia/inex";

export default function Footer() {
  const [footerContent1, setFooterContent1] = useState<FooterContent1[]>([]);
  const [footerContent2, setFooterContent2] = useState<FooterContent2[]>([]);
  const [footerContent3, setFooterContent3] = useState<FooterContent3[]>([]);
  const [footerContent4, setFooterContent4] = useState<FooterContent4[]>([]);
  const [footerContent6, setFooterContent6] = useState<FooterContent6[]>([]);

  useEffect(() => {
    const fetchFooterContent = async () => {
      try {
        // Fetch Footer Content 1
        const content1Data = await footerContent1Service.getFooterContent1();
        setFooterContent1(content1Data);

        // Fetch Footer Content 2 (Maps)
        const content2Data = await footerContent2Service.getFooterContent2();
        setFooterContent2(content2Data);

        // Fetch Footer Content 3 (Contact)
        const content3Data = await footerContent3Service.getFooterContent3();
        setFooterContent3(content3Data);

        // Fetch Footer Content 4 (Timeline)
        const content4Data = await footercontent4Service.getFooterContent4();
        setFooterContent4(content4Data);

        // Fetch Footer Content 6 (Social Media)
        const content6Data = await footercontent6Service.getFooterContent6();
        setFooterContent6(content6Data);
      } catch (error) {
        console.error("Failed to fetch footer content:", error);
      }
    };

    fetchFooterContent();
  }, []);

  // Helper function to remove HTML tags
  const removeHtmlTags = (str: string) => str.replace(/<[^>]*>/g, "");

  return (
    <footer className="py-10 mt-10 text-white bg-gray-800">
      <div className="container px-6 mx-auto max-w-7xl">
        <div className="flex flex-wrap items-start justify-between gap-6">

          {/* Footer Content 1 */}
          <div className="max-w-[220px]">
            {footerContent1.length > 0 ? (
              footerContent1.map((content) => (
                <div key={content.id} className="space-y-2">
                  {content.image && (
                    <img
                      src={`${process.env.REACT_APP_API_URL}${content.image}`}
                      alt={content.title}
                      width={65}
                      height={40}
                    />
                  )}

                  <h4 className="text-base font-semibold">
                    {content.title}
                  </h4>

                  <p className="text-sm leading-relaxed text-gray-300">
                    {removeHtmlTags(content.description)}
                  </p>
                </div>
              ))
            ) : (
              <p>Loading...</p>
            )}
          </div>

          {/* Map */}
          <div className="min-w-[220px]">
            <h3 className="mb-3 text-base font-semibold">Map</h3>

            <div className="w-[230px] h-36 overflow-hidden rounded-lg">
              {footerContent2.length > 0 ? (
                footerContent2.map((content) => (
                  <iframe
                    key={content.id}
                    src={content.link_maps}
                    width="100%"
                    height="100%"
                    loading="lazy"
                    title={content.title}
                  ></iframe>
                ))
              ) : (
                <p>Loading map...</p>
              )}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-3 text-base font-semibold">
              Kontak Kami
            </h3>

            <div className="space-y-1 text-sm leading-relaxed text-gray-300">
              {footerContent3.length > 0 ? (
                footerContent3.map((content) => (
                  <div key={content.id}>
                    <p>{removeHtmlTags(content.description1)}</p>
                    <p>{removeHtmlTags(content.description2)}</p>
                  </div>
                ))
              ) : (
                <p>Loading contact information...</p>
              )}
            </div>
          </div>

          {/* Schedule */}
          <div>
            <h3 className="mb-3 text-base font-semibold">Jadwal</h3>

            <div className="space-y-2 text-sm text-gray-300">
              {footerContent4.length > 0 ? (
                footerContent4.map((content) => (
                  <div key={content.id} className="space-y-1">
                    <h4 className="font-medium text-white">
                      {content.title}
                    </h4>

                    <div className="flex justify-between gap-4">
                      <span>{content.day_1}</span>
                      <span>
                        {content.time_start_1} - {content.time_end_1}
                      </span>
                    </div>

                    <div className="flex justify-between gap-4">
                      <span>{content.day_2}</span>
                      <span>
                        {content.time_start_2} - {content.time_end_2}
                      </span>
                    </div>

                    <div className="flex justify-between gap-4">
                      <span>{content.day_3}</span>
                      <span>
                        {content.time_start_3} - {content.time_end_3}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <p>Loading schedule...</p>
              )}
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="mb-3 text-base font-semibold">Follow</h3>

            {footerContent6.length > 0 ? (
              footerContent6.map((content) => (
                <div
                  key={content.id}
                  className="flex items-center space-x-3"
                >
                  <a
                    href={content.link_ig}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 transition hover:text-white"
                  >
                    <FaInstagram size={24} />
                  </a>

                  <a
                    href={`mailto:${content.link_email}`}
                    className="text-gray-400 transition hover:text-white"
                  >
                    <FaEnvelope size={24} />
                  </a>
                </div>
              ))
            ) : (
              <p>Loading social media links...</p>
            )}
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 mt-12 text-sm text-center text-gray-400 border-t border-gray-700 flex flex-col gap-2">
          <p>© WKJ Kalibakung 2026. All rights reserved.</p>
          <div className="text-xs text-gray-500">
            <p>Created by Universitas Harkat Negeri</p>
            <p className="mt-1">Dwi Intan Af'idah | Aldi Budi Riyanta | Sharfina Febbi Handayani | Mohammad Idham | Muhammad Khadik | M Ilham Rigan Agachi</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
